<template>
  <div>
    <div style="text-align: right;">
    <el-button type="text" size="small"><a class="download-a" download="导入模板.zip"
          href="/doc/鑫达导入模板.zip">导入模板</a></el-button>
    </div>
    <el-form :inline="true" label-width="100px">
      <el-row>
        <el-form-item label="生产队">
          <el-input v-model="queryInfo.teamName" clearable placeholder="请输入" style="width:210px"/>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="queryInfo.name" clearable placeholder="请输入" style="width:210px"/>
        </el-form-item>
      <!-- <el-form-item label="户主">
        <el-input v-model="queryInfo.houseHolderName" clearable placeholder="请输入"/>
      </el-form-item> -->
      <el-form-item label="人员类别">
        <el-select
        v-model="queryInfo.peopleType"
        style="width:210px"
        filterable
        clearable
        :remote-method="remoteMethod"
        remote>
          <el-option
          v-for="item in peopleTypeList"
          :key="item.id"
          :label="item.label"
          :value="item.value"
          />
        </el-select>
        <!-- <el-input v-model="queryInfo.houseHolderName" clearable placeholder="请输入"/> -->
      </el-form-item>
      <el-form-item label="身份证">
        <el-input v-model="queryInfo.idCardNo" clearable placeholder="请输入"  style="width:210px"/>
      </el-form-item>
      </el-row>
     <el-row>
      <!-- 此处农龄改为份额，但是原有代码的中有份额字段，且绑定字段不一致 -->
      <el-form-item label="份额状态">
        <el-select v-model="queryInfo.ageStatus" clearable  style="width:210px">
          <el-option
          v-for="item in ApprovalStatus"
          :key="item.value"
          :label="item.label"
          :value="item.value"/>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="份额状态">
        <el-select v-model="queryInfo.shareStatus" clearable>
          <el-option
          v-for="item in ApprovalStatus"
          :key="item.value"
          :label="item.label"
          :value="item.value"/>
        </el-select>
      </el-form-item> -->
      <!-- 农龄字段替换为份额 -->
      <el-form-item label="份额更新时间">
        <el-date-picker v-model="ageUpdateTime" type="datetimerange" range-separator="至" start-placeholder="开始日期"
                    end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"  :default-time="['00:00:00', '23:59:59']"/>
                        </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="query">查询</el-button>
        <el-button type="primary" @click="addInfo()">信息录入</el-button>
        <el-upload class="upload-demo" action="" :http-request="(item) => uploadFile('info', item)" :show-file-list="false">
          <el-button type="primary">信息导入</el-button>
        </el-upload>
        <el-upload class="upload-demo" action="" :http-request="(item) => uploadFile('age', item)" :show-file-list="false">
          <el-button type="primary">份额导入</el-button>
        </el-upload>
        <!-- <el-upload class="upload-demo" action="" :http-request="(item) => uploadFile('share', item)" :show-file-list="false">
          <el-button type="primary">股份份额导入</el-button>
        </el-upload> -->
        <el-button type="primary" class="upload-demo" @click="exportData">导出</el-button>
      </el-form-item>
     </el-row>
     
    </el-form>
    <table-list
    :loading="loading"
    :data="tableData"
    :page="page"
    :page-size="pageSize"
    :total="totalCount"
    :columnDefs="columnDefs"
    @pageChange="pageChange">
      <template #action={row}>
        <el-button type="text" size="small" @click="showDetailsDialog(row)">查看详情</el-button>
        <el-button type="text" size="small" @click="showAge(row)" v-if="row.ageStatus !== 0">份额管理</el-button>
        <!-- <el-button type="text" size="small" @click="showShareDialog(row)"  v-if="row.stockStatus !== 0">股份份额管理</el-button> -->
      </template>
    </table-list>
    <!-- 信息录入新增/编辑 -->
    <el-dialog
    title="信息录入"
    :close-on-click-modal="false"
    :visible.sync="showInfo"
    :before-close="closeInfo"
    center
    custom-class="info-dialog"
    destroy-on-close>
      <info-dialog ref="InfoDialog" :InfoType="showInfoType" v-if="showInfo" @closeInfo="closeInfo"/>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveInfo" v-if="showInfoType !== 'details' ">保 存</el-button>
        <el-button  type="primary" @click="closeInfo" >关 闭</el-button>
      </div>
    </el-dialog>
    <!-- 农龄管理 三个可以共用一个dialog 但是有点麻烦 状态判断比较多 还是拆分吧 -->
    <el-dialog
    title="份额管理"
    :visible="showAgriculturalAge"
    :before-close="closeInfo"
    center
    custom-class="age-dialog"
    destroy-on-close>
      <age-manage
      :id="ageApplyNo"
      :farmerNo="farmerNo"
      :farmerName="farmerName"
      v-if="showAgriculturalAge"
      @closeInfo="closeInfo"
      />
    </el-dialog>
    <!-- 股份份额管理 -->
    <el-dialog
    title="股份份额管理"
    :visible.sync="showShare"
    :before-close="closeInfo"
    center
    custom-class="age-dialog"
    destroy-on-close>
      <share-manage
      :id="stockApplyNo"
      :farmerNo="farmerNo"
      v-if="showShare"
      @closeInfo="closeInfo"/>
    </el-dialog>
    <!-- 详情 -->
    <el-dialog
    title=""
    :visible.sync="showDetails"
    :before-close="closeInfo"
    center
    custom-class="age-dialog"
    destroy-on-close>
      <details-all
      @closeInfo="closeInfo"
      :infoDetails="infoDetails"
      :lastAgeApplyNo="lastAgeApplyNo"
      :lastStockApplyNo="lastStockApplyNo"
      :stockApplyNo="stockApplyNo"
      :farmerNo="farmerNo"
      :farmerName="farmerName"
      :ageApplyNo="ageApplyNo"
      v-if="showDetails"
      @showUsed="showUsed"/>
    </el-dialog>
    <!-- 导出 -->
    <export-dialog ref="ExportDialog" :queryInfo="queryInfo"/>
    <!-- 上一次审批通过 -->
    <el-dialog
    title=""
    :visible.sync="showUsedData"
    :before-close="showUsed"
    center
    custom-class="age-dialog"
    destroy-on-close>
      <age-manage
      InfoType="details"
      :id="ageApplyNo"
      :farmerNo="farmerNo"
      :farmerName="farmerName"
      :isDetail="isDetail"
      ref="ageManage"
      v-if="showUsedType === 'age'"
      />
      <share-manage
      InfoType="details"
      :id="stockApplyNo"
      :farmerNo="farmerNo"
      v-if="showUsedType === 'share'"
      />
    </el-dialog>
  </div>
</template>

<script>
import TableList from '@/components/TableList.vue'
import InfoDialog from './infoDialog.vue'
import AgeManage from './ageManage.vue'
import ShareManage from './shareManage.vue'
import DetailsAll from './detailsAll.vue'
import ExportDialog from './exportDialog.vue'
// import { ApprovalStatus } from '@/utils/constants'
import { euFarmerInfoQuery, batchImport } from '@/api/community.js'
export default {
  data () {
    return {
      ApprovalStatus: [
        {
          value: -1,
          label: '未录入'
        },
        {
          value: 0,
          label: '待审核'
        },
        {
          value: 1,
          label: '已通过'
        },
        {
          value: 2,
          label: '已拒绝'
        }
      ],
      queryInfo: {
        teamName: '',
        name: '',
        // houseHolderName: '',
        peopleType: '',
        idCardNo: '',
        ageStatus: '',
        shareStatus: '',
      },
      ageUpdateTime: [],
      page: 1,
      pageSize: 10,
      totalCount: 0,
      tableData: [],
      loading: false,
      columnDefs: [
        { label: '人员编号', prop: 'farmerSortNo' },
        { label: '姓名', prop: 'farmerName' },
        { 
          label: '性别',
          formatter: (row) => {
            return row.gender ? row.gender === 1 ? '男' : '女' : ''
          }
        },
        { label: '民族', prop: 'national' },
        { label: '身份证号', prop: 'idCardNo', width: 180 },
        { label: '生产队', prop: 'teamName' },
        {
          label: '份额状态',
          formatter: (row) => {
            let status = this.ApprovalStatus.find(item => item.value === row.ageStatus)
            return status?.label || ''
          }
        },
        { label: '份额更新时间', prop: 'ageUpdateTime', width: 160 },
        // {
        //   label: '份额状态',
        //   formatter: (row) => {
        //     let status = this.ApprovalStatus.find(item => item.value === row.stockStatus)
        //     return status?.label || ''
        //   }
        // },
        { label: '出生年月', prop: 'birthday' },
        { label: '户主', prop: 'houseHolderName' },
        { label: '与户主关系', prop: 'houseHolderRelation' },
        { label: '人员性质', prop: 'peopleNature' },
        { label: '人员类别', prop: 'peopleType' },
        { label: '现居住地', prop: 'livePlace' },
        { label: '联系电话', prop: 'phone' },
        { label: '银行卡号', prop: 'bankCardNo' },
        { label: '开户行', prop: 'bank' },
        { label: '户籍地址', prop: 'registrationAddress' },
        { label: '户主联系电话', prop: 'houseHolderPhone' },
        { label: '承包地确权总面积（亩）', prop: 'landConfirmTotalArea' },
        { label: '宅基地土地使用面积（m²）', prop: 'landHomesteadArea' },
        { label: '原农龄', prop: 'originAge' },
        { label: '婚嫁等因素调增', prop: 'marriageAdd' },
        { label: '婚嫁等因素调减', prop: 'marriageMinus' },
        { label: '按规定调减农龄', prop: 'regulationsAdjust' },
        { label: '核定农龄', prop: 'checkedAge' },
        { label: '继承调增', prop: 'inheritAdd' },
        { label: '继承调减', prop: 'inheritMinus' },
        { label: '合计份额', prop: 'totalAge' },
        // { label: '总份额（股份）数量', prop: 'totalQuantity', width: 200 },
        // { label: '总份额（股份）金额', prop: 'totalAmount', width: 200 },
        // { label: '农龄份额（股份）数量', prop: 'farmerAgeQuantity', width: 200 },
        // { label: '土地份额（股份）数量', prop: 'landQuantity', width: 200 },
        // { label: '土地份额（股份）金额', prop: 'landAmount', width: 200 },
        // { label: '人口份额（股份）数量', prop: 'populationQuantity', width: 200 },
        // { label: '人口份额（股份）金额', prop: 'populationAmount', width: 200 },
        // { label: '继承份额（股份）数量', prop: 'inheritQuantity', width: 200 },
        // { label: '继承份额（股份）金额', prop: 'inheritAmount', width: 200 },
        // { label: '其他份额（股份）数量', prop: 'otherQuantity', width: 200 },
        // { label: '其他份额（股份）金额', prop: 'otherAmount', width: 200 },
        { label: '操作', prop: 'action', width: 240 }
      ],
      showInfo: false,
      showAgriculturalAge: false,
      ageApplyNo: '',
      lastAgeApplyNo: '',
      showShare: false,
      stockApplyNo: '',
      lastStockApplyNo: '',
      showDetails: false,
      farmerNo: '', // 当前行农民编号
      farmerName: '', // 当前行农民姓名
      showInfoType: '',
      showUsedData: false,
      showUsedType: '', // age 农龄 share 份额
      infoDetails: {}, // 人员详情（后端无接口 直接从列表取）
      peopleList: [],
      peopleTypeList: [
        {
          label: '正常',
          value: '正常'
        },
        {
          label: '失联',
          value: '失联'
        },
        {
          label: '赠与',
          value: '赠与'
        },
        {
          label: '已故',
          value: '已故'
        },
        {
          label: '冻结',
          value: '冻结'
        },
        {
          label: '五保户',
          value: '五保户'
        },
        {
          label: '冻结1',
          value: '冻结1'
        },
        {
          label: '合并',
          value: '合并'
        },
        {
          label: '赎回',
          value: '赎回'
        }
      ],
      isDetail: true,
      timer: null
    }
  },
  components: {
    TableList,
    InfoDialog,
    AgeManage,
    ShareManage,
    DetailsAll,
    ExportDialog
  },
  methods: {
    async uploadFile(type, item) {
      const url = {
        'info': 'euFarmerInfo',
        'age': 'euFarmerAgeHeritage',
        'share': 'euFarmerStockHeritage'
      }
      let FromDatas = new FormData()
      FromDatas.append('multipartFile', item.file)
      let result = await batchImport(url[type], FromDatas)
      if (result.code !== 0) return
      this.getData()
      this.$message({ type: 'success', message: '上传成功!' })
    },
    exportData () {
      this.$refs.ExportDialog.showDetails()
    },
    query() {
      this.page = 1
      this.getData()
    },
    closeInfo (refresh = false) {
      this.showInfoType = ''
      this.showInfo = false
      this.showAgriculturalAge = false
      this.ageApplyNo = ''
      this.lastAgeApplyNo = ''
      this.farmerNo = ''
      this.showShare = false
      this.stockApplyNo = ''
      this.lastStockApplyNo = ''
      this.showDetails = false
      localStorage.setItem('isDetails', 2)
      if (refresh === true) {
        this.query()
      }
    },
    addInfo (type = 'new') {
      this.showInfoType = type
      this.showInfo = true
    },
    showAge (row) {
      this.showAgriculturalAge = true
      this.ageApplyNo = row.ageApplyNo
      this.lastAgeApplyNo = row.lastAgeApplyNo || row.ageApplyNo
      this.farmerNo = row.farmerNo
      this.farmerName = row.farmerName
      localStorage.setItem('isDetails', 1)
    },
    showShareDialog (row) {
      this.showShare = true
      this.stockApplyNo = row.stockApplyNo
      this.lastStockApplyNo = row.lastStockApplyNo || row.stockApplyNo
      this.farmerNo = row.farmerNo
    },
    showDetailsDialog(row) {
      this.showDetails = true
      this.ageApplyNo = row.ageApplyNo
      this.lastAgeApplyNo = row.lastAgeApplyNo || row.ageApplyNo
      this.stockApplyNo = row.stockApplyNo
      this.lastStockApplyNo = row.lastStockApplyNo || row.stockApplyNo
      this.farmerNo = row.farmerNo
      this.infoDetails = {
        farmerName: row.farmerName || '',
        farmerNo: row.farmerNo || '',
        gender: row.gender || '',
        national: row.national || '',
        idCardNo: row.idCardNo || '',
        birthday: row.birthday || '',
        teamNo: row.teamNo || '',
        peopleNature: row.peopleNature || '',
        livePlace: row.livePlace || '',
        registrationAddress: row.registrationAddress || '',
        phone: row.phone || '',
        bankCardNo: row.bankCardNo || '',
        bank: row.bank || '',
        houseHolderFlag: row.houseHolderFlag,
        houseHolder: row.houseHolder || '',
        houseHolderName: row.houseHolderName || '',
        houseHolderIdCardNo: row.houseHolderIdCardNo || '',
        houseHolderRelation: row.houseHolderRelation || '',
        houseHolderPhone: row.houseHolderPhone || '',
        landConfirmTotalArea: row.landConfirmTotalArea || '',
        landHomesteadArea: row.landHomesteadArea || '',
        totalAge: row.totalAge || 0,
        peopleType: row.peopleType || '',
        onlyShareDisFlag: row.onlyShareDisFlag || 0,
        farmerSortNo: row.farmerSortNo || '',
        id: row.farmerId
      }
    },
    pageChange (page) {
      this.page = page
      this.getData()
    },
    getData () {
      euFarmerInfoQuery({
        ...this.queryInfo,
        pageSize: this.pageSize,
        pageNum: this.page,
        ageUpdateTimeStart: this.ageUpdateTime?.[0] || '',
        ageUpdateTimeEnd: this.ageUpdateTime?.[1] || '',
      }).then(res => {
        const { code, result } = res
        this.loading = false
        if (code !== 0) return
        this.tableData = result.records
        this.totalCount = result.total
      })
    },
    showUsed (data) {
      const { type } = data
      this.showUsedType = type
      this.showUsedData = !this.showUsedData
    },
    saveInfo () {
      this.$refs.InfoDialog.submit()
    },
    getPeopleList (value) {
      euFarmerInfoQuery({
        pageNum: 1,
        pageSize: 100,
        name: value
      }).then(res => {
        const { code, result } = res
        if (code !== 0) return
        this.peopleList = result.records
      })
    },
    remoteMethod (value) {
      clearTimeout(this.timer)
      if (value) {
        this.timer = setTimeout(() => {
          this.getPeopleList(value)
        }, 500)
      } else {
        this.peopleList = []
      }
    },
    closeDetailInfo() {

    }
  },
  mounted () {
    this.query()
  }
}
</script>

<style lang="scss" scoped>
/deep/ .info-dialog {
  min-width: 750px;
  width: 60%;
}
/deep/ .age-dialog {
  min-width: 950px;
  width: 60%;
}
.upload-demo {
  margin-left:10px;
  display: inline-block;
}
.download-a {
  text-decoration: none;
  outline: none;
  color: #1890ff;
}
</style>